import * as React from 'react';
import { ENV, AboutTabItem } from '~/common/enums/enums';
import {
  footerPayload,
  headerPayload,
  navigationPayload,
} from '~/common/payload/payload';
import { AboutLayout } from '~/components/common/common';
import { About } from '~/components/sections/sections';
import { aboutPayload, seoPayload } from './data/data';

const Page: React.FC = () => (
  <AboutLayout
    seoPayload={seoPayload}
    headerPayload={headerPayload}
    footerPayload={footerPayload}
    navigationPayload={navigationPayload}
    activeTabItem={AboutTabItem.INDEX}
    registrationLink={ENV.APP.REGISTRATION_LINK}
  >
    <h1 className="visually-hidden">About</h1>
    <About payload={aboutPayload} />
  </AboutLayout>
);

export { Page };
